<ridango-block-full-width>
    <span class="step" role="text" attr.aria-label="{{'BLOCK_STEP_ARIA_LABEL' | translate}} {{step}}">{{step}}</span>
    <p class="block-full-width__title">{{'PRODUCT_NOTIFICATION_TITLE' | translate}}</p>

    <ng-container *ngIf="!showOptions">
        <p class="block-full-width__description margin-auto-width-620">
            {{'PRODUCT_NOTIFICATION_DESCRIPTION' | translate}}
        </p>

        <div class="flex-center margin-top-20">
            <button class="btn btn--with-border btn--big" type="submit"
                (click)="toggleView()">{{'PRODUCT_NOTIFICATION_ORDER_BUTTON' | translate}}</button>
        </div>
    </ng-container>

    <ng-container *ngIf="showOptions">
        <section class="margin-auto-width-620">
            <form [formGroup]="notificationsForm">
                <section class="notification-options full-width">
                    <div class="notification-options__title hide-mobile">
                        <p>{{'PRODUCT_NOTIFICATION_CATEGORY_TITLE_EMAIL' | translate}}</p>
                        <p>{{'PRODUCT_NOTIFICATION_CATEGORY_TITLE_SMS' | translate}}</p>
                    </div>

                    <div class="notification-options__types">
                        <ng-container *ngFor="let option of notificationsOptions">
                            <p>{{option.title | translate}}</p>

                            <mat-checkbox *ngIf="option.email" color="primary" aria-label="Email checkbox"
                                [value]="option.email" (change)="onCheckboxChange($event)">
                                <span class="hide-desktop">
                                    {{'PRODUCT_NOTIFICATION_CATEGORY_TITLE_EMAIL' | translate}}</span>
                            </mat-checkbox>
                            <mat-checkbox *ngIf="option.phone" color="primary" aria-label="SMS checkbox"
                                [value]="option.phone" (change)="onCheckboxChange($event)">
                                <span class="hide-desktop">
                                    {{'PRODUCT_NOTIFICATION_CATEGORY_TITLE_SMS' |translate}}</span>
                            </mat-checkbox>
                        </ng-container>
                    </div>
                </section>

                <section class="notification-inputs flex flex-justify-center full-width margin-top-20">
                    <mat-form-field *ngIf="notificationsForm.controls.email" class="flex1" appearance="outline">
                        <mat-label>{{'PH_EMAIL' | translate}}</mat-label>
                        <input type="email" matInput placeholder="{{'PH_EMAIL_PLACEHOLDER' | translate}}"
                            [formControl]="notificationsForm.controls.email" required (change)="(submitForm())">
                        <mat-error *ngIf="notificationsForm.controls.email.hasError('required')">
                            {{'LOCAL_INPUT_EMAIL_MISSING' | translate}}</mat-error>
                        <mat-error *ngIf="notificationsForm.controls.email.hasError('email')">
                            {{'LOCAL_INPUT_VALIDATION_EMAIL' | translate}}</mat-error>
                    </mat-form-field>

                    <mat-form-field *ngIf="notificationsForm.controls.mobile_phone" class="flex1" appearance="outline">
                        <mat-label>{{'PH_PHONE' | translate}}</mat-label>
                        <input type="tel" matInput required placeholder="{{'PH_PHONE_PLACEHOLDER' | translate}}"
                            [formControl]="notificationsForm.controls.mobile_phone" required (change)="(submitForm())">
                        <mat-error *ngIf="notificationsForm.controls.mobile_phone.hasError('required')">
                            {{'FIELD_VALIDATION_REQUIRED' | translate}}</mat-error>
                        <mat-error *ngIf="notificationsForm.controls.mobile_phone.hasError('minlength')">
                            {{'LOCAL_INPUT_VALIDATION_MIN_LENGTH' | translate}}</mat-error>
                        <mat-error *ngIf="notificationsForm.controls.mobile_phone.hasError('pattern')">
                            {{'LOCAL_INPUT_VALIDATION_PHONE_PATTERN' | translate}}</mat-error>
                    </mat-form-field>
                </section>
            </form>

            <div class="flex-center margin-top-20">
                <ridango-ui-back-button [showArrow]="false" (onBack)="toggleView()">
                    {{'PRODUCT_NOTIFICATION_CANCEL_BUTTON' | translate}}</ridango-ui-back-button>
            </div>
        </section>
    </ng-container>
</ridango-block-full-width>
